






























































































































































import { Component, Vue } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import { RealworksKenmerk } from '@/api/model/realworks-kenmerk'
const smartMarketing = namespace('smartMarketing')

@Component
export default class CompanySettingsSmartMarketingRealworks extends Vue {
    @smartMarketing.State readonly includeRealworksRelaties!: boolean
    @smartMarketing.State readonly syncedRealworksKenmerken!: string[]
    @smartMarketing.State readonly excludedRealworksKenmerken!: string[]
    @smartMarketing.State readonly syncedRealworksRelatietypes!: string[]
    @smartMarketing.State readonly syncedRealworksStatus!: boolean|null
    @smartMarketing.State readonly loadingRealworksKenmerken!: boolean
    @smartMarketing.State readonly realworksKenmerken!: RealworksKenmerk[]
    @smartMarketing.State readonly loadingRealworksRelatietypes!: boolean
    @smartMarketing.State readonly realworksRelatietypes!: string[]
    @smartMarketing.Action readonly updateRealworksRelatietypes!: () => Promise<void>
    @smartMarketing.Action readonly updateIncludeRealworksRelaties!: (includeRealworksRelaties: boolean) => Promise<void>
    @smartMarketing.Action readonly updateSyncedRealworksKenmerken!: (syncedRealworksKenmerken: string[]) => Promise<void>
    @smartMarketing.Action readonly updateExcludedRealworksKenmerken!: (excludedRealworksKenmerken: string[]) => Promise<void>
    @smartMarketing.Action readonly updateSyncedRealworksRelatietypes!: (syncedRealworksRelatietypes: string[]) => Promise<void>
    @smartMarketing.Action readonly updateSyncedRealworksStatus: (syncedRealworksStatus: boolean|null) => Promise<void>
    @smartMarketing.State readonly loadingRealworksAgendatypes!: boolean
    @smartMarketing.State readonly realworksAgendaEnabled!: boolean
    @smartMarketing.State readonly realworksAgendatypes!: string[]
    @smartMarketing.State readonly syncedRealworksAgendatypes!: string[]
    @smartMarketing.Action readonly updateRealworksAgendatypes!: () => Promise<void>
    @smartMarketing.Action readonly updateRealworksAgendaEnabled!: (enabled: boolean) => Promise<void>
    @smartMarketing.Action readonly updateSyncedRealworksAgendatypes!: (syncedRealworksAgendatypes: string[]) => Promise<void>
    @smartMarketing.State readonly loadingRealworksTaaktypes!: boolean
    @smartMarketing.State readonly realworksTaakEnabled!: boolean
    @smartMarketing.State readonly realworksTaaktypes!: string[]
    @smartMarketing.State readonly syncedRealworksTaaktypes!: string[]
    @smartMarketing.Action readonly updateRealworksTaaktypes!: () => Promise<void>
    @smartMarketing.Action readonly updateRealworksTaakEnabled!: (enabled: boolean) => Promise<void>
    @smartMarketing.Action readonly updateSyncedRealworksTaaktypes!: (syncedRealworksTaaktypes: string[]) => Promise<void>
    @smartMarketing.State readonly loadingContactsCount!: boolean
    @smartMarketing.State readonly contactsCount!: number
    @smartMarketing.State readonly loading!: boolean
    @smartMarketing.Action readonly load!: () => Promise<void>

    mounted(): void {
        this.load()
        this.updateRealworksRelatietypes()
        this.updateRealworksAgendatypes()
        this.updateRealworksTaaktypes()
    }

    get relatietypeOptions() {
        return this.realworksRelatietypes.map(type => ({
            value: type,
            label: type,
        }))
    }

    get agendatypeOptions() {
        return this.realworksAgendatypes.map(type => ({
            value: type,
            label: type,
        }))
    }

    get taaktypeOptions() {
        return this.realworksTaaktypes.map(type => ({
            value: type,
            label: type,
        }))
    }

    get yesNoOptions(): Array<{ label: string, value: boolean }> {
        return [
            { label: this.$t('yes').toString(), value: true },
            { label: this.$t('no').toString(), value: false },
        ]
    }

    get realworksKenmerkenOptions(): Array<{ label: string, value: string }> {
        return this.realworksKenmerken
            .map(kenmerk => ({
                label: kenmerk.omschrijving,
                value: kenmerk.id,
            }))
            .sort((a, b) => a.label.localeCompare(b.label))
    }

    get realworksStatusOptions(): Array<{ label: string, value: boolean }> {
        return [
            { label: this.$t('forms.edit_smart_marketing_form.syncedRealworksStatusOptions.subscribed').toString(), value: true },
            { label: this.$t('forms.edit_smart_marketing_form.syncedRealworksStatusOptions.unsubscribed').toString(), value: false },
            { label: this.$t('forms.edit_smart_marketing_form.syncedRealworksStatusOptions.both').toString(), value: null },
        ]
    }

    get showRealworksAllContactsWarning() {
        if (this.syncedRealworksKenmerken.length > 0) {
            return false
        }

        if (this.excludedRealworksKenmerken.length > 0) {
            return false
        }

        if (this.syncedRealworksRelatietypes.length > 0) {
            return false
        }

        return true
    }
}
